import { createSlice } from '@reduxjs/toolkit';

// Per-list pagination state, keyed by a stable string (e.g. "customers",
// "applications"). Allows page/pageSize to survive route changes such as
// "list → detail → back", which would otherwise unmount the list and lose
// local useState.
const paginationSlice = createSlice({
    name: 'pagination',
    initialState: {},
    reducers: {
        setPaginationState: (state, action) => {
            const { key, page, pageSize } = action.payload || {};
            if (!key) return;
            if (!state[key]) state[key] = {};
            if (page !== undefined) state[key].page = page;
            if (pageSize !== undefined) state[key].pageSize = pageSize;
        },
        resetPagination: (state, action) => {
            const key = action.payload;
            if (key && state[key]) delete state[key];
        }
    }
});

export const { setPaginationState, resetPagination } = paginationSlice.actions;
export default paginationSlice.reducer;
